import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import MenuOptions from './MenuOptions';

import cross from '../images/Cross.svg';
import PlusSign from '../images/plusSign.png';

import { useIconSwapService } from '../Components/IconSwapService.jsx';

export const ResponsiveMenu = ({ showNav, login }: ResponsiveMenuPropTypes) => {
  const history = useHistory();
  const { address } = useIconSwapService();

  useEffect(() => {
    if (!address) return;
  }, [address]);

  const handleChildClick = (e: any) => {
    e.stopPropagation();
  };

  const menuNav = () => {
    if (!address) {
      login();
    } else {
      showNav();
      history.push('/createSwap');
    }
  };

  return (
    <ResponsiveMenuWrapper onClick={handleChildClick}>
      <MenuHeading>
        <TopLine>
          <MenuHeadingText>Menu</MenuHeadingText>
          <CrossImage src={cross} alt="Close" onClick={showNav} />
        </TopLine>
        <MenuHeadingSubText>Welcome to ICONswap.</MenuHeadingSubText>
      </MenuHeading>
      <MenuBody>
        <MenuOptions showNav={showNav} />
      </MenuBody>
      <MenuFooter>
        <SwapButton onClick={() => menuNav()}>
          <PlusSignImage src={PlusSign} alt="plus sign"></PlusSignImage>
          <ButtonText>Create a swap</ButtonText>
        </SwapButton>
      </MenuFooter>
    </ResponsiveMenuWrapper>
  );
};

export default ResponsiveMenu;

const ResponsiveMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 555px;
  width: 100vw;
  border: 1px solid #d3d7e0;
  border-radius: 10px 10px 0 0;
  background-color: #ffffff;
`;

const MenuHeading = styled.div`
  height: 100px;
  padding: 20.5px;
  display: flex;
  flex-direction: column;
`;

const TopLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const MenuHeadingText = styled.span`
  color: #0c0a0b;
  font-family: 'Avenir Next';
  font-size: 19px;
  font-weight: 600;
`;

const CrossImage = styled.img`
  height: 14.82px;
  width: 14px;
`;

const MenuHeadingSubText = styled.span`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const MenuBody = styled.div`
  padding-top: 20px;
  overflow: scroll;
  border-top: 1px solid #e8ebec;
`;

const MenuFooter = styled.div`
  border-top: 1px solid #e8ebec;
  height: 110px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  position: absolute;
  bottom: 0;
`;

const SwapButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  background-color: #007d81;
  height: 50px;
  width: 190px;
  border-radius: 4px;
  @media (max-width: 414px) {
    width: 335px;
  }
`;

const PlusSignImage = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
  margin-right: 10px;
`;

const ButtonText = styled.span`
  font-size: 16px;
  color: #fff;
`;

type ResponsiveMenuPropTypes = {
  showNav: () => void;
  login: () => void;
};
